<script lang="ts">
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Money from "@components/Money.svelte";
    import T from "@components/T.svelte";

    import BasePostModalTagCard from "./BasePostModalTagCard.svelte";

    export let selected: boolean;
    export let productQuickViewEnabled: boolean;
    export let title: string;
    export let imageUrl: string | undefined;
    export let url: string;
    export let variantTitle: string | undefined;
    export let tagId: number;
    export let comparePrice: number | null;
    export let price: number;
    const dispatch = createEventDispatcher();
    const handleBuyClick = () => {
        dispatch("tag_open", tagId);
    };
</script>

<BasePostModalTagCard
    on:tag_select
    on:tag_unselect
    {selected}
    {title}
    {imageUrl}
    {url}
    {variantTitle}
    {tagId}
    {price}
>
    <div class="gw-post-modal-tag_card__price-wrapper">
        <span aria-label="Current price" class="gw-post-modal-tag_card__price">
            <Money amount={price} with_currency />
        </span>
        {#if comparePrice}
            <span
                aria-label="Old price"
                class="gw-post-modal-tag_card__compare-price"
            >
                <del>
                    <Money amount={comparePrice} with_currency />
                </del>
            </span>
        {/if}
    </div>
    <svelte:fragment slot="button">
        {#if price !== 0}
            {#if productQuickViewEnabled}
                <BaseButton
                    on:click={handleBuyClick}
                    class={CN("gw-post-modal-tag_card__button", {
                        "gw-post-modal-tag_card__button--active": selected,
                    })}
                    ariaLabel={`Open ${title} product`}
                >
                    <T namespace="common.PostModal" translationKey="buy" />
                </BaseButton>
            {:else}
                <a
                    href={url}
                    class="gw-post-modal-tag_card__button gw-link-reset-default-styles"
                    class:gw-post-modal-tag_card__button--active={selected}
                    aria-label={`Opens the product ${title} in a new tab`}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <T namespace="common.PostModal" translationKey="buy" />
                </a>
            {/if}
        {/if}
    </svelte:fragment>
</BasePostModalTagCard>

<style>
    .gw-post-modal-tag_card__price-wrapper {
        display: flex;
        flex-direction: column;
        align-items: start;
        margin: 7px 0;
        column-gap: 16px;
        line-height: 1.4;
    }

    .gw-post-modal-tag_card__price {
        color: var(--gw-post-modal-text-color);
        font-size: 1.3em;
        font-weight: 600;
    }

    .gw-post-modal-tag_card__compare-price {
        opacity: 0.7;
        color: var(--gw-dark-text-color);
    }

    .gw-post-modal-tag_card__button,
    :global(.gw-btn.gw-post-modal-tag_card__button) {
        width: 100%;
        padding: 8px 12px;
        border-radius: var(--gw-border-radius-base);
        background-color: var(--gw-post-modal-button-bg);
        color: var(--gw-post-modal-button-text-color);
        font-size: 0.8em;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        text-align: center;
    }

    .gw-post-modal-tag_card__button:hover,
    :global(.gw-post-modal-tag_card__button:hover) {
        background-color: var(--gw-post-modal-button-hover-bg);
        color: var(--gw-white-button-text-color);
    }
    @media all and (max-width: 900px) and (min-width: 425px) {
        .gw-post-modal-tag_card__price-wrapper {
            flex-direction: row;
            align-items: center;
        }
    }
    @media all and (max-width: 768px) and (min-width: 425px) {
        .gw-post-modal-tag_card__button {
            max-width: 160px;
        }
    }
</style>
